import React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';

const componentClass = 'accountPageHeader';

const AccountPageHeader = ({ className, children, subtitle, title, useMoreHeadRoom }) => {
    const classes = classnames(componentClass, className, {
        withMoreHeadRoom: useMoreHeadRoom
    });

    return <div className={classes}>
        <h1>{title}</h1>
        <p>{subtitle}</p>
        { children }
    </div>;
};

AccountPageHeader.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    useMoreHeadRoom: PropTypes.bool
};

export default AccountPageHeader;
